import api from './client';

export const getBookings = (params?: any) => api.get('/bookings/', { params });
export const createBooking = (data: any) => api.post('/bookings/create/', data);
export const getBooking = (id: string) => api.get(`/bookings/${id}/`);
export const confirmBooking = (id: string) => api.post(`/bookings/${id}/confirm/`);
